/* eslint-disable @typescript-eslint/no-explicit-any */
export type ObjectQueueKeyType = string | number;

export class ObjectQueue {
  keys: Array<ObjectQueueKeyType> = [];
  items: Record<ObjectQueueKeyType, any> = {};
  queueSize: number;

  constructor({ size }: { size: number }) {
    this.keys = [];
    this.items = {};
    this.queueSize = size;
  }

  clear() {
    this.keys = [];
    this.items = {};
  }

  size() {
    return Object.keys(this.items).length;
  }

  enqueue({ key, item }: { key: ObjectQueueKeyType, item: any }) {
    this.keys.push(key);
    this.items[key] = item;

    if (Object.keys(this.items).length > this.queueSize) {
      const keyAtFront = this.keys.splice(0, 1)[0];
      delete this.items[keyAtFront];
    }
  }

  get({
    key,
    defaultValue = undefined,
  }: {
    key: ObjectQueueKeyType,
    defaultValue: any,
  }) {
    return this.items[key] ?? defaultValue;
  }

  isEmpty() {
    return Object.keys(this.items).length === 0;
  }
}
